module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="gmf-app-tools-content-heading">\n    <span class="bs-app-tools-content-icon bs-infra3d"></span>\n    <span class="bs-app-tools-content-heading" translate>Strassenfotos BS</span>\n    <a\n        class="infra3d-ext-link fas fa-external-link-alt"\n        ng-click="ctrl.openPopup()"\n        title="{{\'Open in popup\'|translate}}"\n    ></a>\n    <a class="btn close" ng-click="ctrl.active = false">&times;</a>\n</div>\n<div class="bs-app-tools-content-content-infra3d bs-app-tools-content-content">\n    <div id="infra3d"></div>\n</div>\n';

}
return __p
}